module.exports = __webpack_public_path__ + "img/header.4cd422ac.svg";